import React from 'react';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  return <a href="https://wa.me/447921876472" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] text-white px-5 py-3 rounded-full shadow-2xl hover:bg-[#20bd5a] transition-all duration-300 hover:scale-105 group animate-bounce-subtle" aria-label="Contact us on WhatsApp" data-id="element-188">
      <MessageCircle className="w-6 h-6 fill-current" data-id="element-189" />
      <span className="font-bold hidden md:inline" data-id="element-190">Chat with us</span>
      <span className="absolute -top-2 -right-2 w-4 h-4 bg-red-500 rounded-full animate-ping" data-id="element-191"></span>
    </a>;
}